"use no memo";
import {
	createFileRoute,
	Outlet,
	redirect,
	useLocation,
	useNavigate,
} from "@tanstack/react-router";
import { z } from "zod";
import { PageHeader } from "@/components/Organisms/PageHeader/PageHeader";
import { PageLayout } from "@/components/Organisms/PageLayout/PageLayout";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { ViewTransitionTypes, viewTransition } from "@/utils/view-transitions";
export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/activity/logs",
)({
	component: RouteComponent,
	beforeLoad: () => {
		if (
			location.pathname === "/admin/activity/logs" ||
			location.pathname === "/admin/activity/logs/"
		) {
			console.log("Redirecting to org logs");
			// Redirect to default tab (org logs)
			throw redirect({
				to: "/admin/activity/logs/orgLogs",
				replace: true,
				...viewTransition(ViewTransitionTypes.FADE),
			});
		}
	},
	validateSearch: (search) => {
		return z
			.object({
				create: z.enum(["userLogs", "orgLogs"]).optional(),
			})
			.parse(search);
	},
});

function RouteComponent() {
	const { t } = useAppTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	// Extract current tab from the pathname
	const currentTab = location.pathname.includes("/userLogs")
		? "userLogs"
		: "orgLogs";

	const tabs = [
		{ label: t("admin.nav.items.activity.logs.orgLogs.label"), id: "orgLogs" },
		{
			label: t("admin.nav.items.activity.logs.userLogs.label"),
			id: "userLogs",
		},
	];

	return (
		<PageLayout
			header={
				<PageHeader
					type="landing"
					title={t("admin.nav.items.activity.logs.label")}
					description={t("admin.activity.logs.description")}
					showTabs
					tabs={tabs}
					selectedTabId={currentTab}
					onTabChange={(chosen) => {
						navigate({
							to: `/admin/activity/logs/${chosen}`,
							...viewTransition(ViewTransitionTypes.FADE),
						});
					}}
				/>
			}
		>
			<Outlet />
		</PageLayout>
	);
}
